import services from 'api/services';
import {
  GET_EXERCISE_REQUEST,
  GET_EXERCISE_SUCCESS,
  GET_EXERCISE_FAILURE,
  SET_EXERCISE_RATING_REQUEST,
  SET_EXERCISE_RATING_SUCCESS,
  SET_EXERCISE_RATING_FAILURE,
} from './constants';
import { logError } from 'global/errors';

const { ChallengeService } = services;

export const getExercise = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_EXERCISE_REQUEST });
    const exercise = await ChallengeService.getItem(id, 'exercises');
    exercise.image = exercise.backgroundImage?.url;
    exercise.keywords = exercise.tags;
    delete exercise.backgroundImage;
    delete exercise.tags;
    dispatch({ type: GET_EXERCISE_SUCCESS, exercise });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_EXERCISE_FAILURE, error: ex.message });
  }
};

export const setExerciseRating = (rating, testId) => async (dispatch) => {
  try {
    dispatch({ type: SET_EXERCISE_RATING_REQUEST });
    await ChallengeService.setItemRating(rating, testId);
    dispatch({ type: SET_EXERCISE_RATING_SUCCESS });
  } catch (ex) {
    logError(ex);
    dispatch({ type: SET_EXERCISE_RATING_FAILURE, error: ex.message });
  }
};
